<template>
  <b-navbar-nav v-if="menu">
    <b-nav-item
      v-for="item in menu.items"
      :key="item.index"
      :to="item.to"
      :href="item.href"
      :class="`nav-item${isMenuActive ? '--slideIn' : '--slideOut'}`"
    >
      {{ item.title }}
      <div class="floating-line floating-line--show" />
    </b-nav-item>
  </b-navbar-nav>
</template>

<script>
import loader from '@/build-tools/loaders/poetix-cms-loader'

export default {
  data () {
    return {
      menu: null, isMenuActive: false, story: null,
    }
  },
  watch: {
    $route () {
      this.initMenu()
    },
  },
  created () {
    this.initMenu()
  },
  mounted () {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId === 'nav-collapse') this.isMenuActive = isJustShown
    })
  },
  methods: {
    async initMenu () {
      this.story = await loader.getStory('headermenu')
      if (!this.story.content || await this.$storyblokHelper.isInStoryblokEditor()) {
        await this.$storyblokHelper.getContentUpdates(this.story, (updatedMenu) => {
          this.menu = updatedMenu
        })
      } else
        this.menu = this.story.content
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar-nav {
  text-align: center;
  justify-content: center;
  @include media-breakpoint-down(sm) {
    padding-top: 4em;
    padding-bottom: 4em;
    font-size: $spacer * 1.3;
    height: 100vh;
  }
  @include media-breakpoint-up(md) {
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    flex-direction: row !important;
  }
}
</style>
